import React from 'react';
import styles from './AdminMobileProductList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainColor, mainPadd2, pageCommonGap1, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

const AdminMobileProductList = ({ products }) => {
    if (!products || products.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {/* products 배열을 순회하여 각 상품 정보를 출력 */}
            {products && products.map((product, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex>
                            <FlexChild>
                                <div className={styles.borderBottom}>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={pageEH3FontSize}>{product.productName}</P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end" width="auto">
                                            <div className={styles.statusBox}>
                                                <P size={pageEH3FontSize}>판매중</P>
                                            </div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                            </FlexChild>
                            <FlexChild padding="0.5rem 0 0">
                                <HorizontalFlex gap={registerGap2}>
                                    <FlexChild width="auto">
                                        <img className={styles.productImg} src={product.productImg} alt='상품 이미지' />
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex gap={10}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={pageEH3FontSize} color={mainColor}>입호흡</P>
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <P size={pageEH3FontSize}>
                                                    판매가 {product.price ? product.price.toLocaleString() : 0}
                                                </P>
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <P size={pageEH3FontSize}>
                                                    수량 {product.quantity ? product.quantity.toLocaleString() : 0}
                                                </P>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild width="auto">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <div className={styles.modifyBtn}>
                                                    <P size={pageEH3FontSize}>수정</P>
                                                </div>
                                            </FlexChild>
                                            <FlexChild>
                                                <div className={styles.deleteBtn}>
                                                    <P size={pageEH3FontSize}>삭제</P>
                                                </div>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
        </VerticalFlex>
    );
};

export default AdminMobileProductList;